import DateForm from '../../../features/company/components/companyStats/companyStatsDateForm/CompanyStatsDateForm';
import CompanyStatsTable from '../../../features/company/components/companyStats/companyStatsTable/CompanyStatsTable';

import './statisticTab.scss';

const StatisitcTab = () => {
  return (
    <section className="my-account-content user-statistics">
      <header className="user-statistics-header">
        <h2 className="user-statistics-title">Statistiques</h2>
        <DateForm />
      </header>

      <div className="user-statistics-table-wrapper">
        <CompanyStatsTable />
      </div>
    </section>
  );
};

export default StatisitcTab;
